/* eslint-disable */
// WARNING: DO NOT EDIT. This file is automatically generated by AWS Amplify. It will be overwritten.

const awsmobile = {
    "aws_project_region": "us-east-1",
    "aws_cognito_region": "us-east-1",
    "aws_user_pools_id": "us-east-1_pSxRTacBh",
    "aws_user_pools_web_client_id": "27aispu81j2jib0qb4ml7cq9g1",
    "oauth": {},
    "aws_appsync_graphqlEndpoint": "https://lf7ar3plkjc3rduxdy2x6jhage.appsync-api.us-east-1.amazonaws.com/graphql",
    "aws_appsync_region": "us-east-1",
    "aws_appsync_authenticationType": "AMAZON_COGNITO_USER_POOLS",
    "aws_appsync_apiKey": "da2-r4oknufhbre2hds6itt33anhoe"
};


export default awsmobile;
